import { camelToSnake } from 'utils'

export const openGoogleCalendar = (classItem) => {
  const baseUrl = 'https://calendar.google.com/calendar/render?action=TEMPLATE'
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const description = buildClassDescription(classItem)
  const { start, end } = getStartAndEndDateTime(classItem)

  const format = (date) =>
    date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z'

  const params = new URLSearchParams({
    text: classItem.title,
    dates: `${format(start)}/${format(end)}`,
    details: description,
    location: 'ALO Wellness Club On-Demand',
    ctz: userTimeZone
  })

  const finalUrl = `${baseUrl}&${params.toString()}`

  window.open(finalUrl, '_blank', 'noopener,noreferrer')
}

const getRoundedDuration = (humanDuration) => {
  const parts = humanDuration.split(':').map(Number)

  let hours = 0
  let minutes = 0
  let seconds = 0

  if (parts.length === 3) {
    ;[hours, minutes, seconds] = parts
  } else if (parts.length === 2) {
    ;[minutes, seconds] = parts
  } else {
    throw new Error('Invalid duration format')
  }
  const totalMinutes = hours * 60 + minutes + seconds / 60
  // Round UP to next 30-minute block
  return Math.ceil(totalMinutes / 30) * 30
}

export const getCoachNames = (coachList) => {
  return coachList
    ?.map((item) =>
      camelToSnake(item).full_name
        ? camelToSnake(item).full_name
        : `${camelToSnake(item).first_name} ${camelToSnake(item).last_name}`
    )
    .join(', ')
}

const buildClassDescription = (classItem) => {
  const coachList = classItem?.coaches || classItem?.plan?.coaches
  const coachNames = getCoachNames(coachList)

  return [
    `Start Now: ${buildClassUrlWithUtmParams(classItem?.planEntryUrl)}`,
    `Class: ${classItem.title}`,
    `Instructor: ${coachNames}`,
    `Duration: ${getRoundedDuration(classItem.humanDuration)} mins`,
    `Equipment: ${classItem.equipments?.join(', ') || 'None'}`
  ].join('<br>')
}

const getStartAndEndDateTime = (classItem) => {
  const start = new Date(Date.now() + 30 * 60 * 1000)
  const durationMinutes = getRoundedDuration(classItem.humanDuration)
  const end = new Date(start.getTime() + durationMinutes * 60 * 1000)
  return { start, end }
}

const buildClassUrlWithUtmParams = (baseUrl) => {
  const url = new URL(baseUrl)

  url.searchParams.set('utm_source', 'user_calendar')
  url.searchParams.set('utm_medium', 'reminder')
  url.searchParams.set('utm_campaign', 'scheduled_workout')

  return url.toString()
}

export const openOutlookCalendar = (classItem) => {
  const baseUrl = 'https://outlook.office.com/calendar/0/deeplink/compose'
  const description = buildClassDescription(classItem)
  const { start, end } = getStartAndEndDateTime(classItem)

  const params = new URLSearchParams({
    subject: classItem.title,
    startdt: start.toISOString(),
    enddt: end.toISOString(),
    body: description,
    location: 'ALO Wellness Club On-Demand'
  })

  const finalUrl = `${baseUrl}?${params.toString()}`

  window.open(finalUrl, '_blank', 'noopener,noreferrer')
}

export const downloadICS = (classItem) => {
  const now = new Date()
  const { start, end } = getStartAndEndDateTime(classItem)

  const formatICSDate = (date) =>
    date.toISOString().replace(/[-:]|\.\d{3}/g, '')

  const coachList = classItem?.coaches || classItem?.plan?.coaches
  const coachNames = getCoachNames(coachList)

  const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
UID:${Date.now()}
DTSTAMP:${formatICSDate(now)}
DTSTART:${formatICSDate(start)}
DTEND:${formatICSDate(end)}
SUMMARY:${classItem.title}
DESCRIPTION:Start Now: ${buildClassUrlWithUtmParams(
    classItem.planEntryUrl
  )}\\nClass: ${
    classItem.title
  }\\nInstructor: ${coachNames}\\nDuration: ${getRoundedDuration(
    classItem.humanDuration
  )}\\nEquipment: ${classItem.equipments?.join(',')}
LOCATION:ALO Wellness Club On-Demand
BEGIN:VALARM
TRIGGER:-PT30M
ACTION:DISPLAY
DESCRIPTION:Reminder
END:VALARM
BEGIN:VALARM
TRIGGER:-PT15M
ACTION:DISPLAY
DESCRIPTION:Reminder
END:VALARM
END:VEVENT
END:VCALENDAR`.trim()

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' })

  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.href = url
  link.download = `alo-class-${classItem.title}.ics`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
